"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragQuestionViewModel = void 0;
const lodash_1 = require("lodash");
const __1 = require("..");
var DragQuestionViewModel;
(function (DragQuestionViewModel) {
    function mergeComponentsWithAnswer(components, answerComponents, result = undefined) {
        const checkedComponents = result && result.components;
        const newComps = components.map((c) => {
            if (!__1.Component.isBox(c.position) || !c.settings.isDraggable)
                return c;
            const clone = (0, lodash_1.cloneDeep)(c);
            clone.dragIsCorrect =
                checkedComponents && !(0, lodash_1.isEmpty)(checkedComponents) ? checkedComponents[clone._id] === 'correct' : undefined;
            const compAnswer = answerComponents[clone._id];
            if (!compAnswer)
                return clone;
            clone.orgPosition = { ...clone.position };
            const pos = { ...c.position };
            const { top, left } = compAnswer.position;
            const height = 100 - pos.bottom - pos.top;
            const width = 100 - pos.left - pos.right;
            const newBox = {
                top,
                left,
                bottom: 100 - top - height,
                right: 100 - left - width,
            };
            clone.position = newBox;
            clone.inDropzone = compAnswer.inDropzone;
            return clone;
        });
        return newComps;
    }
    DragQuestionViewModel.mergeComponentsWithAnswer = mergeComponentsWithAnswer;
})(DragQuestionViewModel || (exports.DragQuestionViewModel = DragQuestionViewModel = {}));
//# sourceMappingURL=DragQuestionViewModel.js.map